var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXlsx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "filetype_xls") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 8,
    y: 4,
    width: 24,
    height: 32,
    rx: 1
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.3%",
    y: "-3.1%",
    width: "116.7%",
    height: "112.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.127109646   0 0 0 0 0.0591805127   0 0 0 0 0.197180707  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.125490196   0 0 0 0 0.0588235294   0 0 0 0 0.196078431  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filetype_xls",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Paper"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FBF9F6",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "dash",
    fill: "#138147",
    x: 4,
    y: 8,
    width: 20,
    height: 11,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69287109,16 L9.64990234,14.2568359 L10.6069336,16 L11.7998047,16 L10.3129883,13.4912109 L11.762207,11.0234375 L10.5830078,11.0234375 L9.64990234,12.7392578 L8.71679687,11.0234375 L7.53759766,11.0234375 L8.98681641,13.4912109 L7.5,16 L8.69287109,16 Z M15.7985547,16 L15.7985547,15.1762695 L13.6213086,15.1762695 L13.6213086,11.0234375 L12.595918,11.0234375 L12.595918,16 L15.7985547,16 Z M18.4711328,16.0683594 C19.0225651,16.0683594 19.4612044,15.9458822 19.7870508,15.7009277 C20.1128971,15.4559733 20.2758203,15.1181641 20.2758203,14.6875 C20.2758203,14.3001302 20.1425195,13.9765625 19.875918,13.7167969 C19.6093164,13.4570312 19.184349,13.2394206 18.6010156,13.0639648 C18.2842839,12.9682617 18.0444564,12.8657227 17.8815332,12.7563477 C17.71861,12.6469727 17.6371484,12.5113932 17.6371484,12.3496094 C17.6371484,12.1764323 17.7066471,12.0368652 17.8456445,11.9309082 C17.9846419,11.8249512 18.1794661,11.7719727 18.4301172,11.7719727 C18.6898828,11.7719727 18.891543,11.8352051 19.0350977,11.9616699 C19.1786523,12.0881348 19.2504297,12.2652995 19.2504297,12.4931641 L19.2504297,12.4931641 L20.2758203,12.4931641 C20.2758203,12.1946615 20.198916,11.9280599 20.0451074,11.6933594 C19.8912988,11.4586589 19.6753971,11.2769368 19.3974023,11.1481934 C19.1194076,11.0194499 18.8026758,10.9550781 18.447207,10.9550781 C18.0940169,10.9550781 17.7755762,11.0143229 17.4918848,11.1328125 C17.2081934,11.2513021 16.9905827,11.4159342 16.8390527,11.626709 C16.6875228,11.8374837 16.6117578,12.0773112 16.6117578,12.3461914 C16.6117578,12.863444 16.8943099,13.2747396 17.4594141,13.5800781 C17.6667708,13.6917318 17.9481836,13.8050944 18.3036523,13.920166 C18.6591211,14.0352376 18.9052148,14.1446126 19.0419336,14.248291 C19.1786523,14.3519694 19.2470117,14.500651 19.2470117,14.6943359 C19.2470117,14.8720703 19.1786523,15.010498 19.0419336,15.1096191 C18.9052148,15.2087402 18.7149479,15.2583008 18.4711328,15.2583008 C17.8148828,15.2583008 17.4867578,14.983724 17.4867578,14.4345703 L17.4867578,14.4345703 L16.4579492,14.4345703 C16.4579492,14.7558594 16.5405501,15.0384115 16.705752,15.2822266 C16.8709538,15.5260417 17.1107812,15.7180176 17.4252344,15.8581543 C17.7396875,15.998291 18.0883203,16.0683594 18.4711328,16.0683594 Z",
    id: "XLS",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.cffcec5f50d70de39bc6cf4a1fda34a4.svg";
export { ForwardRef as ReactComponent };